export default __webpack_public_path__ + "static/media/cern-extrabold.0f3d2523.eot";